module.exports = __webpack_public_path__ + "img/apple-store.5f9ecd74.jpg";